import { Button, Grid, TextField } from '@mui/material';
import CustomTypography, {
  TypographyType,
} from 'components/core/CustomTypography';
import { Workflow } from 'protos/v1alpha2/workflows_service';
import React, { useState } from 'react';
import { OrganizationsService } from 'services/OrganizationsService';
import { toastService } from 'services/ToastService';
import EmailsAdditionComponent from './components/EmailsAdditionComponent';
import WorkflowTemplatesSelector from './components/WorkflowTemplatesSelector';

const CreateOrganization: React.FC = () => {
  const [selectedTemplates, setSelectedTemplates] = useState<Workflow[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  const [selectedAdmins, setSelectedAdmins] = useState<string[]>([]);
  const [orgDisplayName, setOrgDisplayName] = useState<string>('');
  const isButtonEnabled = orgDisplayName.trim() !== '';

  const handleCreateOrganization = () => {
    if (orgDisplayName.trim() === '') {
      toastService.showError('Organization name cannot be empty');
      return;
    }
    // Create organization with the given data
    OrganizationsService.getInstance()
      .createOrganization({
        organization: {
          displayName: orgDisplayName,
          users: selectedUsers,
          admins: selectedAdmins,
          workflowTemplateTypes: selectedTemplates.map(
            (t) => t.workflowTemplateType!,
          ),
        },
      })
      .then(() => {
        setSelectedAdmins([]);
        setSelectedUsers([]);
        setSelectedTemplates([]);
        setOrgDisplayName('');
        toastService.showSuccess('Organization created successfully');
      })
      .catch((e) => {
        toastService.showError(`Failed to create organization: ${e}`);
      });
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{ width: '60vw', margin: '16px' }}
      justifyContent='end'
    >
      <Grid item xs={12}>
        <CustomTypography typographyType={TypographyType.Bolder}>
          Create Organization
        </CustomTypography>
      </Grid>
      <Grid item xs={12}>
        <CustomTypography
          typographyType={TypographyType.Label}
          sx={{ margin: '5px 0' }}
        >
          Organization Name
        </CustomTypography>
        <TextField
          id='orgName'
          variant='outlined'
          value={orgDisplayName}
          onChange={(e) => setOrgDisplayName(e.target.value)}
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <EmailsAdditionComponent
          addedEmails={selectedUsers}
          setAddedEmails={setSelectedUsers}
          label="Add Users' Emails"
        />
      </Grid>
      <Grid item xs={6}>
        <EmailsAdditionComponent
          addedEmails={selectedAdmins}
          setAddedEmails={setSelectedAdmins}
          label="Add Admins' Emails"
        />
      </Grid>
      <Grid item xs={12}>
        <WorkflowTemplatesSelector
          selectedTemplates={selectedTemplates}
          setSelectedTemplates={setSelectedTemplates}
        />
      </Grid>
      <Grid item>
        <Button
          variant='contained'
          onClick={handleCreateOrganization}
          disabled={!isButtonEnabled}
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  );
};

export default CreateOrganization;
